<div class="page-container">
	<div class="section filter-items">
		<div class="table-actions">
			<div class="action-item left">
				<app-switch-control [formGroup]="form" name="showArchived" label="Show Archived" />
			</div>
			<div class="action-item right">
				<button type="button" class="btn btn-sm btn-primary" (click)="onAddNewClick()">
					<i class="bi bi-plus"> </i>
					Add new
				</button>
			</div>
		</div>
	</div>
	<div class="content">
		<div class="section table-container">
			<div class="table-headings">
				<div class="column-name long">Name</div>
				<div class="column-name long">Description</div>
				<div class="column-name action"></div>
			</div>

			<app-loading-state [isLoading]="isLoading" [loadedContent]="loadedContent"></app-loading-state>
			<ng-template #loadedContent>
				<ng-container *ngIf="categoryItems.length === 0; else invCatTable">
					<div class="table-row">
						<div class="inner-row">
							<em class="fw-bold"> No inventory categories. </em>
						</div>
					</div>
				</ng-container>
				<ng-template #invCatTable>
					<ng-container *ngFor="let item of categoryItems">
						<div class="table-row">
							<div class="inner-row long">
								{{ item.name | nullDefault: '-' }}
							</div>
							<div class="inner-row long">
								{{ item.description | nullDefault: '-' }}
							</div>
							<div class="inner-row action">
								<div class="dropdown">
									<button class="btn btn-sm" type="button" data-bs-toggle="dropdown" aria-expanded="false">
										<i class="bi bi-three-dots"></i>
									</button>
									<ul class="dropdown-menu">
										<li>
											<button role="button" class="dropdown-item" (click)="onInventoryCategoryEdit(item)">
												Edit
											</button>
										</li>
										<li *ngIf="item.archived === false">
											<button role="button" class="dropdown-item" (click)="onInventoryCategoryArchive(item)">
												<div class="text-danger">Archive</div>
											</button>
										</li>
										<li *ngIf="item.archived === true">
											<button role="button" class="dropdown-item" (click)="onInventoryCategoryUnarchive(item)">
												<div class="text-danger">Unarchive</div>
											</button>
										</li>
									</ul>
								</div>
							</div>
						</div>
					</ng-container>
				</ng-template>
			</ng-template>
		</div>
	</div>
</div>
